import React, { useEffect } from "react";
import { LoginForm } from "../Components/custom/LoginForm";
import { setDynamicTitle } from "../Utils/dynamicTitleManager";

export const Login = () => {
  // Use dynamic title management
  useEffect(() => {
    setDynamicTitle("Login");
  }, []);

  // LoginForm renders the full-screen split layout (brand panel + sign-in)
  return <LoginForm />;
};